import { PlanPrivacy, PlanType, SubscriptionType } from "common/app-plans";
import { IconImage } from "common/components/SerializedApp";
import { GlideFC } from "lib/glide-fc";
import { useCallback } from "react";
import { styled } from "sharedUI/styles";
import AppPlanPanel from "./app-plan-panel";

interface Props {
    appIcon: IconImage;
    appAccentColor: string;
    showProOnly: boolean;
    plan: PlanType | undefined;
    privacy: PlanPrivacy;
    subscription: SubscriptionType;
    planChange: (plan: PlanType) => void;
    privacyChange: (privacy: PlanPrivacy) => void;
}

const AppPlansContainer = styled.div<{ showProOnly: boolean }>`
    width: ${p => (p.showProOnly ? 522 : 796)}px;
    display: flex;
    justify-content: space-between;
`;

const AppPlans: GlideFC<Props> = p => {
    const { appIcon, appAccentColor, plan, privacy, subscription, planChange, privacyChange, showProOnly } = p;

    const onBasicSelected = useCallback(() => {
        planChange(PlanType.Basic);
        privacyChange(PlanPrivacy.Public);
    }, [planChange, privacyChange]);

    const onProSelected = useCallback(() => {
        planChange(PlanType.Pro);
        privacyChange(PlanPrivacy.Public);
    }, [planChange, privacyChange]);

    const onPrivateProSelected = useCallback(() => {
        planChange(PlanType.Pro);
        privacyChange(PlanPrivacy.Private);
    }, [planChange, privacyChange]);

    return (
        <AppPlansContainer showProOnly={showProOnly}>
            {!showProOnly && (
                <AppPlanPanel
                    plan={PlanType.Basic}
                    privacy={PlanPrivacy.Public}
                    subscription={subscription}
                    appAccentColor={appAccentColor}
                    appIcon={appIcon}
                    selected={plan === PlanType.Basic && privacy === PlanPrivacy.Public}
                    onSelect={onBasicSelected}
                />
            )}
            <AppPlanPanel
                plan={PlanType.Pro}
                privacy={PlanPrivacy.Public}
                subscription={subscription}
                appAccentColor={appAccentColor}
                appIcon={appIcon}
                selected={plan === PlanType.Pro && privacy === PlanPrivacy.Public}
                onSelect={onProSelected}
            />
            <AppPlanPanel
                plan={PlanType.Pro}
                privacy={PlanPrivacy.Private}
                subscription={subscription}
                appAccentColor={appAccentColor}
                appIcon={appIcon}
                selected={plan === PlanType.Pro && privacy === PlanPrivacy.Private}
                onSelect={onPrivateProSelected}
            />
        </AppPlansContainer>
    );
};

export default AppPlans;
